module.exports = __webpack_public_path__ + "static/media/PO.f82c5fc0.svg";